import { isMediaMessage, isRegularMessage, isSpecialMessage, isTextMessage, MessagingChannel } from "@whatsper/texterchat-common";
export var ChatPaneName;
(function (ChatPaneName) {
    ChatPaneName["search"] = "search";
    ChatPaneName["media"] = "media";
})(ChatPaneName || (ChatPaneName = {}));
export const channelSupportsTM = (channelName) => {
    return [
        MessagingChannel.whatsapp,
    ].includes(channelName);
};
/**
 * Quotes the replied message in the text itself, for channels without native quoting.
 * Special messages (like post comments) have nothing readable to quote, so text is left as is.
 */
export const withReplyQuote = (text, replyMessage) => {
    var _a;
    if (isSpecialMessage(replyMessage)) {
        return text;
    }
    if (isTextMessage(replyMessage) && replyMessage.text) {
        return `> ${replyMessage.text}\n\n${text}`;
    }
    if (isMediaMessage(replyMessage)) {
        const caption = (_a = replyMessage.media.find((media) => media.caption)) === null || _a === void 0 ? void 0 : _a.caption;
        if (caption) {
            return `> ${caption}\n\n${text}`;
        }
    }
    if (isRegularMessage(replyMessage)) {
        return `> ${replyMessage.type}\n\n${text}`;
    }
    return text;
};
